import { useEffect, useState } from "react"
import { MatchResultSearchFilter, MatchResultView } from "../../interfaces/MatchResult"
import { PageBuilder } from "../../utils/Page"
import { executeMatch, searchMatchResult } from "../../api"
import { Button, Form, DatePicker, Table, notification, Modal } from "antd"
import { format } from 'date-fns';
import './index.css'

const MatchResult = () => {
    const [searchFilter, setSearchFilter] = useState<MatchResultSearchFilter>({})
    const [data, setData] = useState<MatchResultView[]>()
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [totalElements, setTotalElements] = useState<number>(500)
    const [api, contextHolder] = notification.useNotification();
    const columns = [
        {
            title: "序号",
            dataIndex: "serial",
        },
        {
            title: "捐助编号",
            dataIndex: "donationNumber"
        },
        {
            title: "金额",
            dataIndex: "amount",
        },
        {
            title: "受助编号",
            dataIndex: "assistanceNumber"
        },
        {
            title: "备注",
            dataIndex: "remark"
        },
        {
            title: "匹配时间",
            dataIndex: "matchTime",
            render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        }
    ]
    const search = async () => {
        const page = new PageBuilder()
            .setPage(current - 1)
            .setSize(pageSize)
            .build()
        const { data } = await searchMatchResult({
            params: { ...page, searchFilterCombineOperation: "AND" },
            filters: searchFilter
        })
        setData(data.content)
        setTotalElements(data.totalElements)
    }
    const handleSearch = async (filter: MatchResultSearchFilter) => {
        console.log(filter)
        setSearchFilter(filter)
    }

    const handleTableChange = (pagination: any) => {
        setCurrent(pagination.current)
        setPageSize(pagination.pageSize)
    }

    const handleMatch = async () => {
        Modal.confirm({
            title: '执行匹配',
            content: '确定执行匹配吗？',
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                const result: any = await executeMatch()
                if (result.status === 200) {
                    //下载返回的 csv 参考: https://stackoverflow.com/questions/65684497/how-to-save-csv-file-from-api-response-using-react
                    const url = URL.createObjectURL(new Blob([result.data],{
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', "matchResult.xlsx")
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    URL.revokeObjectURL(url)
                    //刷新页面
                    await search()
                } else {
                    api.error({
                        message: `匹配失败！`,
                        description: result.message,
                        placement: 'top',
                    });
                }
            }
        })
    }

    useEffect(() => { search() }, [searchFilter, current, pageSize])

    return (
        <div>
            {contextHolder}
            <div className="flex-box">
                <Form<MatchResultSearchFilter>
                    layout="inline"
                    onFinish={handleSearch}
                >
                    <Form.Item
                        label="匹配开始时间: "
                        name="matchTimeAfter"
                    >
                        <DatePicker />
                    </Form.Item>
                    <Form.Item
                        label="匹配结束时间: "
                        name="matchTimeBefore"
                    >
                        <DatePicker />
                    </Form.Item>
                    <div className="search-button">
                        <Form.Item>
                            <Button htmlType="reset" type="default">重置</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit" type="primary">搜索</Button>
                        </Form.Item>
                    </div>
                </Form>
                <Button color="danger" variant="solid" size="large" shape="round" onClick={handleMatch}>执行匹配</Button>
            </div>

            <Table<MatchResultView> rowKey={'id'} columns={columns} dataSource={data}
                pagination={{
                    current: current,
                    total: totalElements,
                    hideOnSinglePage: true
                }}
                onChange={handleTableChange}
            />
        </div>
    )
}

export default MatchResult